// extracted by mini-css-extract-plugin
export default {"Error":"Error_Error__mpntW","button-container":"Error_button-container__+dF46"};